// src/components/TermsOfService.tsx
import { Paper, Title, Text, Stack, ScrollArea, Box } from '@mantine/core';

function TermsOfService() {
	return (
		<Box h='calc(100vh - 92px)'>
			<ScrollArea h='100%' type='scroll'>
				<Paper p='md' radius='md' withBorder>
					<Stack gap='md'>
						<Title order={2}>Terms of Service</Title>
						<Text size='sm'>Last updated: January 21, 2025</Text>

						<Stack gap='xl'>
							<section>
								<Text fw={500} size='lg'>
									1. Agreement to Terms
								</Text>
								<Text size='sm'>
									By accessing or using the Bill Tracker
									mobile application, you agree to be bound by
									these Terms of Service and all applicable
									laws and regulations. If you do not agree
									with any of these terms, you are prohibited
									from using the app.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									2. Use License
								</Text>
								<Text size='sm'>
									Permission is granted to use Bill Tracker
									for personal, non-commercial use. This
									license shall automatically terminate if you
									violate any of these restrictions.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									3. Disclaimer
								</Text>
								<Text size='sm'>
									The materials within Bill Tracker are
									provided on an 'as is' basis. 99 Solutions
									makes no warranties, expressed or implied,
									and hereby disclaims and negates all other
									warranties including, without limitation,
									implied warranties or conditions of
									merchantability, fitness for a particular
									purpose, or non-infringement of intellectual
									property.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									4. Limitations
								</Text>
								<Text size='sm'>
									In no event shall 99 Solutions or its
									suppliers be liable for any damages
									(including, without limitation, damages for
									loss of data or profit, or due to business
									interruption) arising out of the use or
									inability to use Bill Tracker.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									5. Accuracy of Materials
								</Text>
								<Text size='sm'>
									The materials appearing in Bill Tracker
									could include technical, typographical, or
									photographic errors. 99 Solutions does not
									warrant that any of the materials are
									accurate, complete, or current.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									6. Links
								</Text>
								<Text size='sm'>
									99 Solutions has not reviewed all of the
									sites linked to its mobile application and
									is not responsible for the contents of any
									such linked site. The inclusion of any link
									does not imply endorsement by 99 Solutions.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									7. Modifications
								</Text>
								<Text size='sm'>
									99 Solutions may revise these Terms of
									Service at any time without notice. By using
									Bill Tracker, you agree to be bound by the
									current version of these Terms of Service.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									8. Governing Law
								</Text>
								<Text size='sm'>
									These terms and conditions are governed by
									and construed in accordance with the laws of
									[Your Jurisdiction] and you irrevocably
									submit to the exclusive jurisdiction of the
									courts in that location.
								</Text>
							</section>
						</Stack>
					</Stack>
				</Paper>
			</ScrollArea>
		</Box>
	);
}

export default TermsOfService;
